import EventEmitter from "events";

export default class EventBus {
    static session: EventEmitter = new EventEmitter();
    static error: EventEmitter = new EventEmitter();
    static visibility: EventEmitter = new EventEmitter();
    static components: EventEmitter = new EventEmitter();
    // Saving or deleting a dashboard changes what the rail under Home should name. The page that
    // made the change and the rail that lists them are in different trees, so neither can hand the
    // other a callback.
    static dashboards: EventEmitter = new EventEmitter();
    // Opening the owner hierarchy from a Stewardship cell. A cell renderer is called per ROW
    // and cannot own a drawer; the drawer is mounted once and listens here.
    static ownerHierarchy: EventEmitter = new EventEmitter();
}